import LegalPage, { type LegalSection } from "@/components/public/LegalPage";

const SECTIONS: LegalSection[] = [
  { id: "editor" },
  { id: "director" },
  { id: "hosting" },
  { id: "saasHosting" },
  { id: "intellectual" },
  { id: "liability" },
  { id: "mediation" },
];

export default function LegalNotice() {
  return (
    <LegalPage
      namespace="legal.legalNotice"
      sections={SECTIONS}
      lastUpdated="2026-05-13"
      contactEmail="contact@delapresse.fr"
    />
  );
}
